import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';

import { cn } from '../../utils';

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer group h-5 w-5 shrink-0 cursor-pointer rounded-md border-2 border-border bg-background shadow-hard-sm ring-offset-background transition-all duration-200 ease-spring enabled:hover:border-foreground/40 active:translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-riso-pink data-[state=checked]:bg-riso-pink data-[state=checked]:text-white data-[state=checked]:shadow-hard-pink data-[state=indeterminate]:border-riso-pink data-[state=indeterminate]:bg-riso-pink data-[state=indeterminate]:text-white data-[state=indeterminate]:shadow-hard-pink',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex animate-check-pop items-center justify-center text-current">
      <Check
        className="h-3.5 w-3.5 group-data-[state=indeterminate]:hidden"
        strokeWidth={3}
      />
      <Minus
        className="hidden h-3.5 w-3.5 group-data-[state=indeterminate]:block"
        strokeWidth={3}
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
